<script>
  import LightBox from '../assets/general/ImageLightBox.svelte';
  import Title from '../assets/general/title.svelte';
  import TitleCard from '../assets/general/TitleCard.svelte';
  import Button from '../routes/button.svelte';
  import Video from '../assets/home/video.svelte';
  import Testimonial from '../assets/training/testimonial.svelte';
</script>

<TitleCard
  header="Training"
  backgroundImage="OldOfficeBagsOnChairs.jpg"
/>
<br><br>
<main>
  <h1>Freedom Writers Teacher Institute</h1>
  <div class="container">
    <div class="left-column">
      <div class="left-container">
      <p>Imagine helping all of your students reach their fullest potential. You understand the struggles they bring into the classroom every day; you feel in tune with your identity and mission as a teacher; and you work with purpose and intentionality to empower your students. What’s more, you feel confident in your ability to make a difference; you consistently teach culturally relevant content; and you rally fellow educators at your school site to serve students with compassion and empathy.</p>
      </div>
    </div>
    <div class="right-column">
      <LightBox 
        imageUrl="../images/other/ErinInstitute.png"
        imageWidth="100%"
        imageHeight="auto"
        title="Erin Gruwell at Freedom Writers Teacher Institute"
        altText="Future Freedom Writer Teachers adopt and ingest the pedagogy of world renowned educator Erin Gruwell at our professional development training known as the Freedom Writers Teachers Institute."
      />
    </div>
  </div>
  <p style="font-family: 'Oswald'; font-size:1.17rem;"><strong>The Freedom Writers Teacher Institute will help you #BetheTeacher you want to see in the world.</strong></p>
  <br><br>
  <p>The Teacher Institute is a 5-day intensive workshop in Long Beach, CA, led by renowned educator Erin Gruwell. While most professional development for educators emphasizes pedagogy or classroom management, Ms. G’s primary focus at the Institute is developing you, the educator, as an individual. You step into her classroom as a student, and leave better prepared to empower your own students.<br><br>You’ll gain:<ul><li>First-hand insights about Ms. G’s teaching methodology</li><li>A full tool chest of activities, frameworks, and lesson plans</li><li>A renewed sense of purpose in the classroom</li><li>Exclusive access to the global Freedom Writer Teacher network</li></ul>
  <p>Apply today for an upcoming Institute!</p>
</main>
<div class="button-container">
  <Button
    text="LEARN MORE"
    link="mailto:richard@freedomwritersfoundation.org"
  />
</div>
<div class="video-container">
  <Video
  videoSRC="https://www.youtube.com/embed/HnMWgmA0HhI?si=WUfAO5iaB1WugBmq"
  />
</div>
<main>
  <p style="font-family: 'Oswald'; font-size: 2rem; padding: 2rem 0 2rem;"><strong>Are you a superintendent?</strong></p>
  <p>You can sponsor a Freedom Writers Teacher Institute exclusively for teachers and staff in your school district. Here’s what two superintendents say about the Institute’s impact on their districts:</p>
</main>
<div class="split-screen">
    <div class="half">
      <Testimonial
        text="150 people in our district have gone through the Institute -- teachers, principals, administrators, and board members -- and more will come. Those who go through the Institute are transformed. They have a new way of being and of looking at things. They are more capable and confident, more purposeful and passionate. Our students feel that someone cares about them. The Institute helps us do more and be better. I always want Erin to be part of what we do. I only wish I would have found the Institute back when I was a classroom teacher."
        image="../images/other/Kedziora.jpg"
        name="Dr. Martinrex Kedziora"
        subtitle="Former Superintendent, Moreno Valley Unified School District"
      />
    </div>
    <div class="half">
      <Testimonial
        text="I get asked all the time, 'Why do you keep sending your people to Long Beach?' The answer is that the Institute has helped our staff better understand the needs of our students, and the importance of building relationships with them. It's not about pedagogy; it's about understanding the kids right in front of us. If we can better understand them and their needs, the greater chance we have of capturing their interest and serving them well. The Institute allows us to see things from numerous perspectives. And the bonds that are formed last far beyond the five days in Long Beach."
        image="../images/other/Rocco.jpg"
        name="Rocco Migliori"
        subtitle="Superintendent, Westmoreland Central School District"
      />
    </div>
  </div>
<div class="button-container">
  <Button
  text="SEND ME AN APPLICATION"
  link="mailto:richard@freedomwritersfoundation.org"
  />
</div>

<style>
  .split-screen {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    width: 90%;
    margin: 0 auto;
  }

  .half {
    flex: 1 1 45%;
    position: relative;
    margin: 1rem;
    width: 450px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  /* Add the first child pseudo-element for the vertical divider */
  .half:first-child::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 5%;
    width: 1px;
    background-color: #f7931e;
    display: block;
  }

.video-container {
  margin: 0 5% 0 5%;
}

.button-container {
  margin: 1rem 0 1rem;
  text-align: center;
}

ul {
  font-family: 'Oswald';
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.7rem;
  margin: 1rem 0 1rem 7rem;
}

h1 {
  font-size: 2.5rem;
  font-family: 'Oswald', sans-serif;
  text-align: center;
}

p {
  font-size: 1rem;
  font-family: 'Arial';
  line-height: 1.7rem;
}

.container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1rem; /* This sets the gap between the grid items */
  align-items: start; /* Aligns items at the start of the container */
  width: 100%;
}

.left-column, .right-column {
  /* Adjustments for columns can be placed here */
}

.left-container {
  padding-right: 7%; /* Adjust padding to give some space between the columns */
}

.right-column {
  display: grid;
  gap: 1rem; /* This sets the gap between the Lightbox components */
  padding: 3%;
}

@media (max-width: 768px) {
  .split-screen {
      flex-direction: column;
    }
  .half {
      width: 90%;
    }
  .half:first-child {
        padding-bottom: 1rem;
        border-bottom: 1px solid #f7931e; /* Adds a horizontal line for visual separation */
    }

    /* Removes the vertical line for mobile views */
  .half:first-child::after {
        content: none;
    }

  .container {
    display: block; /* Switch back to standard block layout */
  }

  .left-column, .right-column {
    width: 100%;
    padding: 0;
  }

  ul {
    margin: 1rem 0 1rem 3rem;
  }

  .right-column {
    padding: 1rem 0;
  }

  .left-container {
    padding: 0 7%;
  }
}

main {
  margin: 0 7%;
}
</style>